import type {
  UpdateInvoiceCurrencyRequestPayload,
  UpdateInvoiceCurrencyResponse,
} from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type UpdateInvoiceCurrencyPayload = {
  invoiceId: string;
  updateInvoiceCurrencyRequest: UpdateInvoiceCurrencyRequestPayload;
};

export function useUpdateInvoiceCurrency(
  options?: UseMutationOptions<UpdateInvoiceCurrencyResponse, unknown, UpdateInvoiceCurrencyPayload>,
) {
  return useMutation({
    mutationFn: async ({ invoiceId, updateInvoiceCurrencyRequest }) => {
      const api = getPrivateApi();

      // @ts-expect-error OpenAPI Generator doesn't handle nullable $ref enums — modifiedCurrency should be Currency | null
      return api.updateInvoiceCurrency({ invoiceId, updateInvoiceCurrencyRequest });
    },
    ...options,
  });
}
